import Cookies from "js-cookie";
import { CookieNames } from "./cookie-names";
export function removeOIDCCookie() {
    Cookies.remove(CookieNames.OIDC_COOKIE);
}
export function removeRefreshTokenCookie() {
    Cookies.remove(CookieNames.LLL_REFRESH_TOKEN);
}
